import { render, staticRenderFns } from "./QuizBet.vue?vue&type=template&id=8fedec00&scoped=true"
import script from "./QuizBet.vue?vue&type=script&lang=js"
export * from "./QuizBet.vue?vue&type=script&lang=js"
import style0 from "./QuizBet.vue?vue&type=style&index=0&id=8fedec00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fedec00",
  null
  
)

export default component.exports